import React, { useState, useRef, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import CountUp from 'react-countup';

function WatchShowcase() {
  const [viewPortEntered, setViewPortEntered] = useState(false);
  const statsRef = useRef(null);

  const stats = [
    { number: 40, suffix: 'm', label: 'Max Depth', icon: 'fas fa-arrow-down' },
    { number: 16, suffix: '', label: 'Tissue Compartments', icon: 'fas fa-lungs' },
    { number: 10, suffix: 's', label: 'Update Interval', icon: 'fas fa-sync' }
  ];

  const watchFeatures = [
    {
      title: 'Scuba Mode',
      description: 'Full decompression computer with NDL, safety stops, and ascent rate monitoring',
      icon: 'fas fa-swimmer'
    },
    {
      title: 'Snorkeling Mode',
      description: 'Track surface-to-depth cycles with automatic sub-dive detection',
      icon: 'fas fa-fish'
    },
    {
      title: 'Digital Crown Control',
      description: 'Navigate between dive modes and control your dive with the Digital Crown',
      icon: 'fas fa-circle-notch'
    },
    {
      title: 'Water Lock Integration',
      description: 'Automatic water lock activation with crown-to-exit mechanism',
      icon: 'fas fa-lock'
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !viewPortEntered) {
          setViewPortEntered(true);
        }
      },
      {
        threshold: 0.3,
        rootMargin: '50px'
      }
    );

    const currentRef = statsRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [viewPortEntered]);

  return (
    <section id="watch" className="section-padding">
      <Container>
        <div className="text-center mb-5" data-aos="fade-up">
          <h2 className="section-title">Your Ultimate Dive Companion</h2>
          <p className="section-subtitle">
            Your Apple Watch becomes your reliable dive companion.
          </p>
        </div>

        <div className="watch-showcase mb-5" data-aos="zoom-in" ref={statsRef}>
          <Row>
            {stats.map((stat, index) => (
              <Col md={4} sm={4} className="mb-3" key={index}>
                <div className="stat-card">
                  <i className={stat.icon} style={{ fontSize: '2rem', marginBottom: '1rem' }}></i>
                  <div className="stat-number">
                    <CountUp
                      start={viewPortEntered ? 0 : null}
                      end={stat.number}
                      duration={2}
                      suffix={stat.suffix}
                    />
                  </div>
                  <div className="stat-label">{stat.label}</div>
                </div>
              </Col>
            ))}
          </Row>
        </div>

        <Row>
          {watchFeatures.map((feature, index) => (
            <Col lg={6} className="mb-4" key={index} data-aos="fade-up" data-aos-delay={index * 100}>
              <div className="watch-feature-item">
                <div className="watch-feature-icon">
                  <i className={feature.icon} style={{ color: 'white', fontSize: '1.5rem' }}></i>
                </div>
                <div>
                  <h4>{feature.title}</h4>
                  <p>{feature.description}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        <div className="text-center mt-5" data-aos="fade-up">
          <div className="ultra-showcase">
            <h3 className="mb-3">Apple Watch Ultra Optimized</h3>
            <p className="mb-4" style={{ fontSize: '1.1rem', opacity: 0.95 }}>
              Take advantage of the Apple Watch Ultra's enhanced diving capabilities with extended 
              battery life, improved water resistance, and precision depth gauge up to 40 meters.
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '2rem', flexWrap: 'wrap' }}>
              <div>
                <i className="fas fa-water" style={{ fontSize: '2rem' }}></i>
                <p className="mt-2">WR100 Rating</p>
              </div>
              <div>
                <i className="fas fa-temperature-low" style={{ fontSize: '2rem' }}></i>
                <p className="mt-2">-20°C to 55°C</p>
              </div>
              <div>
                <i className="fas fa-mountain" style={{ fontSize: '2rem' }}></i>
                <p className="mt-2">Altitude Ready</p>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default WatchShowcase;